// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productTextBadgesStyles } from "@insite/content-library/Components/ProductTextBadges";
import { css } from "styled-components";

productTextBadgesStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        gap: 4px 8px;
        flex-wrap: wrap;
        .tooltip-container {
            display: flex;
        }
    `,
};
productTextBadgesStyles.badge = {
    css: css``,
};
productTextBadgesStyles.badgeText = {
    weight: "bold",
    size: 10,
    lineHeight: "16px",
    css: css`
        width: 100%;
        margin: auto;
        ${wrapInContainerStyles}
    `,
};
